import { apiWithToken } from '../../systems/api';

export default {
	getAuthToken: () => apiWithToken.post('admin/v1/auth/auth-only-token'),
};
